<template>
  <div class="legal">
    <!-- Hero -->
    <section class="legal__hero container">
      <p class="eyebrow reveal">Qui édite ce site</p>
      <h1 class="legal__title reveal" style="animation-delay:.05s">
        Mentions<br><span class="hl">légales</span>
      </h1>
      <p class="legal__lead reveal" style="animation-delay:.12s">
        Les infos officielles, comme la loi le demande. Rien de bien palpitant,
        mais c'est important.
      </p>
      <p class="legal__updated reveal" style="animation-delay:.16s">
        Dernière mise à jour&nbsp;: 10&nbsp;juillet&nbsp;2026
      </p>
    </section>

    <section class="container prose">
      <article class="block reveal">
        <h2>Éditeur du site</h2>
        <p>
          Le site <strong>labanane.net</strong> est édité à titre personnel et
          <strong>non commercial</strong> par <strong>Yann&nbsp;F.</strong>
        </p>
        <p>
          Contact&nbsp;:
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>
        </p>
        <p class="note">
          S'agissant d'un site personnel non professionnel, l'adresse postale de
          l'éditeur n'est pas publiée, conformément à la possibilité offerte par
          l'article 6 III 2° de la LCEN. Elle est tenue à la disposition de
          l'hébergeur et des autorités compétentes.
        </p>
      </article>

      <article class="block reveal">
        <h2>Directeur de la publication</h2>
        <p>
          Le directeur de la publication est l'éditeur du site,
          <strong>Yann&nbsp;F.</strong>, joignable à
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>.
        </p>
      </article>

      <article class="block reveal">
        <h2>Hébergement</h2>
        <p>Le site est hébergé par&nbsp;:</p>
        <div class="card">
          <p class="card__name">Amazon Web Services EMEA SARL</p>
          <p>38 avenue John F. Kennedy<br>L-1855 Luxembourg</p>
          <p class="card__note">
            Infrastructure et base de données hébergées dans la région
            <strong>eu-west-3 (Paris, France)</strong>, au sein de l'Union
            européenne.<br>
            <a class="mail" href="https://aws.amazon.com" target="_blank" rel="noopener">aws.amazon.com</a>
          </p>
        </div>
      </article>

      <article class="block reveal">
        <h2>Propriété intellectuelle</h2>
        <p>
          La Banane est un <strong>projet de préservation</strong> du site de
          blagues francophone <strong>labanane.org</strong>, actif du début des
          années 2000 jusqu'à sa disparition vers 2017. Les
          <strong>2&nbsp;440 blagues «&nbsp;legacy&nbsp;»</strong> présentées ici
          proviennent de ce site original&nbsp;: elles ont été écrites, proposées et
          votées par sa communauté d'anonymes à l'époque, et récupérées depuis les
          archives publiques du web (Wayback Machine).
        </p>
        <p>
          <strong>Ces blagues d'origine ne nous appartiennent pas.</strong> Elles
          sont reproduites dans un but d'hommage et de conservation d'un patrimoine
          culturel populaire, sans aucune exploitation commerciale. Si vous êtes un
          auteur d'origine ou un ayant droit et souhaitez un crédit, une correction
          ou le retrait d'un contenu, écrivez-nous à
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>&nbsp;:
          la porte est grande ouverte.
        </p>
        <p>
          Les contenus soumis par les utilisateurs après le revival (nouvelles
          blagues, commentaires) restent la propriété de leurs auteurs, qui en
          concèdent la diffusion sur le site (voir les
          <router-link class="ilink" to="/cgu">CGU</router-link>). Le reste du site
          — nom, identité visuelle, textes de présentation, code — relève de
          l'éditeur.
        </p>
      </article>

      <article class="block reveal">
        <h2>Signalement de contenu</h2>
        <p>
          Pour signaler un contenu que vous jugez illicite, inapproprié ou portant
          atteinte à vos droits, contactez-nous à
          <a class="mail" href="mailto:contact@labanane.net">contact@labanane.net</a>.
          On traite ces demandes avec sérieux et réactivité.
        </p>
      </article>

      <p class="seealso reveal">
        Voir aussi&nbsp;:
        <router-link to="/confidentialite">Politique de confidentialité</router-link> ·
        <router-link to="/cgu">Conditions d'utilisation</router-link>
      </p>
    </section>

    <section class="container legal__cta">
      <BananaButton to="/" size="lg" variant="dark">🍌 Retour aux blagues</BananaButton>
    </section>
  </div>
</template>

<script>
import BananaButton from '@/components/ui/BananaButton.vue'

export default {
  name: 'PageMentionsLegales',
  components: { BananaButton },
}
</script>

<style scoped>
.legal__hero { text-align: center; padding: 56px 20px 24px; }
.legal__title { font-size: clamp(2.4rem, 7vw, 4.4rem); }
.hl { color: var(--banana-700); }
.legal__lead {
  font-family: var(--font-accent);
  font-style: italic;
  font-size: clamp(1.15rem, 2.6vw, 1.5rem);
  color: var(--ink-700);
  max-width: 600px;
  margin: 10px auto 0;
}
.legal__updated {
  font-size: 0.85rem;
  color: var(--ink-500);
  margin: 14px auto 0;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.prose { display: flex; flex-direction: column; gap: 26px; padding: 20px 20px 10px; }

.block h2 { font-size: clamp(1.35rem, 3.4vw, 1.95rem); margin-bottom: 0.5em; }
.block p { font-size: 1.08rem; line-height: 1.7; color: var(--ink-800); margin: 0 0 0.9em; }
.block p:last-child { margin-bottom: 0; }
.block strong { color: var(--ink-900); }
.note { font-size: 0.98rem !important; color: var(--ink-500) !important; font-style: italic; }

.mail {
  color: var(--banana-800);
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 2px;
  word-break: break-word;
}
.mail:hover { color: var(--banana-700); }
.ilink { color: var(--banana-800); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }
.ilink:hover { color: var(--banana-700); }

.card {
  background: var(--surface);
  border: var(--border-w) solid var(--border-c);
  border-radius: var(--r-md);
  padding: 18px 22px;
  box-shadow: var(--shadow-sm);
}
.card p { margin: 0 0 0.4em; font-size: 1.02rem; line-height: 1.55; }
.card p:last-child { margin-bottom: 0; }
.card__name { font-family: var(--font-display); font-weight: 800; color: var(--ink-900); font-size: 1.1rem; }
.card__note { font-size: 0.95rem !important; color: var(--ink-700) !important; margin-top: 0.6em !important; }

.seealso {
  text-align: center;
  font-size: 0.95rem;
  color: var(--ink-500);
  margin: 6px 0 0;
}
.seealso a { color: var(--banana-800); font-weight: 600; text-decoration: underline; text-underline-offset: 3px; }
.seealso a:hover { color: var(--banana-700); }

.legal__cta { text-align: center; padding: 26px 20px 60px; }

@media (max-width: 620px) {
  .legal__hero { padding: 40px 4px 20px; }
  .prose { padding-left: 4px; padding-right: 4px; }
}
</style>
